import { CustomerViewModel } from '@models/api-customers.models';
import { ClubNecessaryFields } from '@features/club/club.model';

/**
 * @description Check if the customer fields are filled
 * @param data the customer data
 * @param fields the fields to check, if not provided, the default fields will be checked, which is all the fields
 * @returns boolean
 */
export const checkCustomerFieldsData = (
    data: CustomerViewModel,
    fields?: ClubNecessaryFields | ClubNecessaryFields[]
): ClubNecessaryFields[] => {
    const defaultFields = ['phoneNumber1', 'city', 'street', 'postalCode', 'birthDate'] as ClubNecessaryFields[];

    if (!fields || fields.length === 0) {
        fields = defaultFields;
    }

    if (fields && !Array.isArray(fields)) {
        fields = [fields];
    }

    return fields.filter((field: ClubNecessaryFields) => {
        // special case for birthDate because the field could not come, and we need to inform the user to fill it
        if (field === 'birthDate') {
            return !data.birthDate || data.birthDate === '01-01-0001' || data.birthDate === '';
        }

        if (isKeyOf(data, field)) {
            if (!data[field] || data[field] === '') {
                return true;
            }
        } else if (isKeyOf(data?.address || {}, field) || !data.address) {
            if (!data.address?.[field] || data.address?.[field] === '') {
                return true;
            }
        }

        return false;
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isKeyOf = <T extends object>(obj: T, key: keyof any): key is keyof T => {
    return key in obj;
};
